import { MessagesModel } from '@/Shared/domain'

export const ApiStep1And2FormErrorFieldAdapter = (
  errorMessage: MessagesModel,
): string => {
  switch (errorMessage.value) {
    case 'merchantCIF':
      return 'cif'
    case 'propietaryContact.contactEmailAddress':
      return 'billingEmail'
    case 'propietaryContact.contactPhone':
      return 'billingPhone'
    case 'billingContact.contactEmailAddress':
      return 'paymentEmail'
    case 'billingContact.contactPhone':
      return 'paymentPhone'
    case 'storeData.merchantName':
      return 'storeName'
    case 'storeData.addressZipCode':
      return 'storePostalCode'
    case 'storeData.addressEmail':
      return 'storeEmail'
    case 'storeData.merchantWebUrl':
      return 'storeWeb'
    case 'attendantContact.contacFirstName':
      return 'contactName'
    case 'attendantContact.contactSurname1':
      return 'contactSurname1'
    case 'attendantContact.contactEmailAddress':
      return 'contactEmail'
    default:
      return ''
  }
}

export const ApiSignUpFormErrorFieldAdapter = (errorMessage: MessagesModel): string => {
  switch (errorMessage.value) {
    case 'userName':
      return 'username'
    case 'email':
      return 'email'
    default:
      return ''
  }
}
